import signOut from './arrowRightFromBracket';

export const faSignOut = signOut('classic', 'thin');
export const falSignOut = signOut('classic', 'light');
export const fatSignOut = signOut('classic', 'thin');
export const fadSignOut = signOut('duotone', 'thin');
export const fasSignOut = signOut('classic', 'solid');
export const farSignOut = signOut('classic', 'regular');

export default signOut;
